import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../components/BaseComponent';
import { Check } from '../../components/Icon';
import { selectIsLoggedIn } from '../../modules/Api/selectors';
import './style.scss';

const Container = styled.div``;

/* eslint-disable react/prefer-stateless-function */
class HomeComp extends BaseComponent {
  componentDidMount() {}

  render() {
    return (
      <Container className="home-container">
        <h3>Home</h3>
        {!this.props.loggedIn ? (
          <Link to="/login">Login</Link>
        ) : (
          <>
            <Check />
            Logged in <br />
            <Link to="/boards">Borden</Link>
          </>
        )}
      </Container>
    );
  }
}

HomeComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    loggedIn: selectIsLoggedIn(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const Home = compose(
  withConnect,
  withRouter,
)(HomeComp);
